__webpack_require__.p = "https://ca-bulletproof-test.proudsky-7617c128.uksouth.azurecontainerapps.io/_next/";